export const formatDuration = (durationSeconds: number): string => {
  const hours = Math.floor(durationSeconds / 3600)
  const minutes = Math.floor((durationSeconds % 3600) / 60)
  const seconds = (durationSeconds % 3600) % 60
  let retVal = ''
  if (hours) {
    retVal += `${hours}h `
  }
  if (minutes) {
    retVal += `${minutes}m `
  }
  retVal += `${seconds}s`
  return retVal.trim()
}